import { branch, compose, renderNothing, withHandlers, withState } from 'recompose'
import PromoExpirationNotification from './PromoExpirationNotification'
import { getCurrentStorePhoneNumber } from 'selectors/getCurrentStore'
import { formatPhoneNumber } from 'helpers/phone-number'
import { connect } from 'react-redux'
import { getPromotionDetailsList } from 'components/ShoppingQuote/BOTProductAndServicesQuoteNew/components/PromotionExpirationModal/selectors'

const mapStateToProps = (state) => ({
  storePhoneNumber: getCurrentStorePhoneNumber(state),
  formattedStorePhoneNumber: formatPhoneNumber(getCurrentStorePhoneNumber(state)),
  promotionDetailsList: getPromotionDetailsList(state)
})

const withIsVisible = withState('showNotification', 'setShowNotification', true)

const withRenderNothing = branch(
  ({ showNotification }) => !showNotification,
  renderNothing
)

const withCloseHandler = withHandlers({
  handleCloseNotification: ({ setShowNotification }) => () => {
    setShowNotification(false)
  }
})

export default compose(
  connect(mapStateToProps),
  withIsVisible,
  withRenderNothing,
  withCloseHandler
)(PromoExpirationNotification)
